import http from './http'

export default class KindEditorApi {
	static saveUserPage(data) {
		return http.httpPost('/lavrock/edit/userpage', data)
	}
}
